const React = require('react');
const formatNum = require('mn-utils/formatNum');

const {getAdminStatistic} = require("../../../../../api/admin/statistic");
const WrapperWithLoading = require('../../../../dumb/WrapperWithLoading/B');
const withState = require('../../../../../utils/withState');

const DataBlock = require("./DataBlock");

module.exports = withState((setState, self, onMount) => {
  const currencyCode = 'EUR';

  self.state = {
    loading: false
  };

  onMount(() => {
    getAdminStatistic().then((res) => {
      const {
        pending_invoices = {},
        volumes_fee_overall = {},
        volumes_monthly = {},
        volumes_overall = {},
      } = res.finance || {};

      setState({
        invoices: pending_invoices[currencyCode].amount,
        volumesFeeOverall: volumes_fee_overall[currencyCode].amount,
        monthlyVolumes: volumes_monthly[currencyCode].amount,
        overallVolumes: volumes_overall[currencyCode].amount,
        loading: false,
      });
    });
  });

  const formAmountString = (amount) => `${self.state.loading ? '120 000' : formatNum(amount)} ${currencyCode}`;

  return (state) => {
    const {
      invoices,
      volumesFeeOverall,
      monthlyVolumes,
      overallVolumes
    } = state;

    const overallData = [
      {
        name: 'Aggregated Monthly transacted volume',
        value: formAmountString(monthlyVolumes),
      },
      {
        name: 'Aggregated monthly Pending Invoice',
        value: formAmountString(invoices),
      },
      {
        name: 'Overall Transacted volume',
        value: formAmountString(overallVolumes),
      },
      {
        name: 'Overall commisions earned',
        value: formAmountString(volumesFeeOverall),
      },
    ];

    return (
      <WrapperWithLoading
        className="mt34"
        loading={state.loading}
      >
        <DataBlock items={overallData.slice(0, 2)} />
        <DataBlock items={overallData.slice(2, 4)} />
      </WrapperWithLoading>
    )
  }
})